import { FieldProps } from 'formik'
import React from 'react'
import { Form } from 'react-bulma-components'
import FormField, { FormFieldProps } from './form-field'
import { get } from 'lodash'

interface SelectFieldOption {
  value: string
  label: string
  [key: string]: any
}

interface SelectFieldProps extends FormFieldProps, FieldProps {
  options: SelectFieldOption[]
  selectDefaultChooseOptionLabel?: string
}

const SelectField: React.FunctionComponent<SelectFieldProps> = props => {
  const { field, form, options, selectDefaultChooseOptionLabel, ...rest } = props

  return (
    <FormField label={props.label} error={get(form.errors, field.name) as string}>
      <Form.Select {...field} {...rest} value={field.value} fullwidth>
        <option style={{ display: 'none' }} value={undefined}>
          {selectDefaultChooseOptionLabel ?? 'Choose...'}
        </option>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </Form.Select>
    </FormField>
  )
}

export default SelectField
